<template>
	<TemplateBase :is-sales="isSales">
		<div
			v-if="pageTitle"
			class="bg-gradient-to-r from-purple-700 to-purple-900 top-0 py-24 lg:py-32 w-full flex items-center"
		>
			<div class="container flex flex-col gap-8 z-10 items-start">
				<h1
					class="text-white drop-shadow-lg font-display text-display-size-xs lg:text-display-size-sm font-bold"
				>
					{{ pageTitle }}
				</h1>
				<LazyAtomBreadcrumbs
					v-if="breadcrumbs"
					:breadcrumbs="breadcrumbs"
					class="text-functional-size-sm"
				/>
			</div>
		</div>
		<div class="bg-gray-50">
			<slot />
		</div>
	</TemplateBase>
</template>

<script lang="ts" setup>
import type { BreadcrumbsType } from '#base/core/types/BreadcrumbsType';

defineProps<{
	pageTitle?: string;
	breadcrumbs?: BreadcrumbsType;
	isSales?: boolean;
}>();
</script>
